function startCountdownTimer() {
  setInterval(function () {
    var d = new Date();

    var hours = 23 - d.getHours();
    if (hours < 10) hours = '0' + hours;

    var min = 59 - d.getMinutes();
    if (min < 10) min = '0' + min;

    var sec = 59 - d.getSeconds();
    if (sec < 10) sec = '0' + sec;

    let timeElements = document.getElementsByClassName('aus_timerr');

    for (let i = 0; i < timeElements.length; i++) {
      const wrapper = timeElements[i].closest('.cstm-tb-heading');
      const days = wrapper ? wrapper.dataset.days : '00';

      const dd = days < 10 ? '0' + days : days;

      timeElements[i].innerHTML = `${dd}:${hours}:${min}:${sec}`;
    }
  }, 1000);
}

startCountdownTimer();


document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});